import { BASE_API_URL, ENV } from "config/configUrl";

import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecordContext } from "react-admin";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { StatusLabel } from "../../../components/Label/status";
import InfoRow from "../../../components/Common/InfoRow";
import QuickViewCard from "../../../components/Common/QuickViewCard";
import { formatCrypto, formatDateTime, formatEuro } from "../../../utils/paymentFormat";

// The payer's page of an order: the pay.coinhouse.io page in production, the
// Solutions API page (/pay/<id>) elsewhere.
const paymentPageUrl = (id: string) =>
  (ENV as string) === "production" ? `https://pay.coinhouse.io/${id}` : `${BASE_API_URL}/pay/${id}`;

function RecentActivity({ conversions }: { conversions: any[] }) {
  const { t }: { t: any } = useTranslation();
  const record = useRecordContext();
  return (
    <QuickViewCard
      actions={
        record.statusOrder === "CREATED" && (
          <Button variant="outlined" color="secondary" endIcon={<OpenInNewRoundedIcon />} onClick={() => window.open(paymentPageUrl(String(record.id)), "_blank")}>
            {t("Open payment page")}
          </Button>
        )
      }
    >
      <InfoRow label={t("Status")}>
        <StatusLabel fontSize="small" />
      </InfoRow>
      {record.euroAmount !== undefined && <InfoRow label={t("Euro amount")}>{formatEuro(record.euroAmount)}</InfoRow>}
      <InfoRow label={t("Crypto amount")}>
        {formatCrypto(record.amount)} {String(record.currency || "").toUpperCase()}
      </InfoRow>
      {conversions.map((conversion: any, index: number) => (
        <InfoRow key={conversion.id || index} label={conversions.length > 1 ? `${t("Conversion")} ${index + 1}` : t("Conversion")}>
          <StatusLabel fontSize="small" statusField="status" record={conversion} />
        </InfoRow>
      ))}
      <InfoRow label={t("Created date")}>{formatDateTime(record.dateCreated)}</InfoRow>
    </QuickViewCard>
  );
}

export default RecentActivity;
